import { AsyncGridColumns, ColumnLink } from '~/shared/ui/AsyncGrid'
import { ButtonGoWebSite } from './ButtonGoWebSite'
import { GridRow } from './types'

export const columns: AsyncGridColumns<GridRow> = [
  {
    headerName: 'column.designation',
    field: 'name',
    sortable: false,
    flex: 1,
    renderCell: ({ row }) => <ColumnLink to={row.id}>{row.name}</ColumnLink>,
  },
  {
    headerName: 'column.full designation',
    field: 'fullName',
    sortable: false,
    flex: 1,
  },
  {
    headerName: 'column.phone number',
    field: 'phoneNumber',
    sortable: false,
    flex: 1,
  },
  {
    headerName: 'column.e-mail',
    field: 'email',
    sortable: false,
    flex: 1,
  },
  {
    headerName: 'column.head',
    field: 'directorFio',
    sortable: false,
    flex: 1,
  },
  {
    headerName: 'column.website',
    field: 'webSite',
    sortable: false,
    flex: 1,
    renderCell: ({ row }) =>
      row.webSite && <ButtonGoWebSite webSite={row.webSite} />,
  },
]
